const KEY_PREFIX = 'profileUnlockReminded:'

/** 列表页已弹出过扣费确认时调用，资料页据此不再二次提醒。 */
export function markProfileUnlockReminded(uuid) {
  if (!uuid || typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(KEY_PREFIX + uuid, '1')
}

/** 资料页读取并清除来源标记。 */
export function consumeProfileUnlockReminded(uuid) {
  if (!uuid || typeof sessionStorage === 'undefined') return false
  const key = KEY_PREFIX + uuid
  const reminded = sessionStorage.getItem(key) === '1'
  sessionStorage.removeItem(key)
  return reminded
}

export const PROFILE_UNLOCK_NEED_CONFIRM = 412
export const PROFILE_UNLOCK_COST = 10
export const PROFILE_UNLOCK_CONFIRM_MESSAGE = '你还没访问过该用户，查看需要扣除10分，是否继续查看？'
